import { Flex, Typography } from "antd"

export const ManualPayoutsStepUi = () => {
  return (
    <Typography.Text>
      Here, you can send payouts by manually entering the recipient's wallet
      address, amount, and currency.
      <br />
      Before sending, you can choose who will cover the blockchain network fee:
      <br />
      Sender – You cover the fee, and the recipient receives the full amount.
      <br />
      Recipient – The fee is deducted from the transfer, and the recipient
      receives a reduced amount.
    </Typography.Text>
  )
}
